<style scoped lang="scss">
.this__1 {
  flex: 0 0 43.47%;
}
.this__2 {
  flex: 0 0 18.6%;
}
.this__3 {
  flex: 0 0 26.06%;
  justify-content: flex-end;
}

@media (max-width: 1440px) {
  .this__3 {
    flex: 0 0 15.86%;
    flex-direction: column;
    align-items: flex-end !important;

    * {
      align-self: flex-end !important;
    }
  }
}

@media (max-width: 1280px) {
  .this__1 {
    flex: 0 0 45.47%;
  }
  .this__2 {
    flex: 0 0 28.6%;
  }
  .this__3 {
    flex: 0 0 17.86%;
  }
}

@media (max-width: 1098px) {
  .this__3 {
    flex: 0 0 20.86%;
  }
}

@media screen and (max-width: 991px) {
  #demo__Footer {
    flex-direction: column-reverse !important;
  }
  .this__part {
    width: 100%;
    flex: 0 0 100%;
    margin: 0;
    margin-top: 8px;
  }
  .this__3 {
    justify-content: flex-start !important;
    flex-direction: row !important;
    align-items: flex-start !important;
    * {
      align-self: flex-start !important;
    }
  }
}

@media screen and (max-width: 520px) {
  .this__3 {
    flex-direction: column !important;
    * {
      margin: 0 !important;
    }
  }
}
</style>
<template>
  <div
    id="demo__Footer"
    class="demo__flex demo__flex-middle demo__flex-between demo__color--white demo__font-left demo__padding-left--20 demo__padding-right--20 demo__padding-bottom--27"
  >
    <div class="demo__font--12 demo__weight--400 this__1 this__part">
      {{ $t("Licence") }}
    </div>
    <div class="demo__font--12 demo__weight--400 this__2 this__part">
      <div>
        <a
          :href="userLinks.userAgreement"
          class="demo__pointer demo__color--white"
          target="_blank"
        >
          {{ $t("User Agreement") }}
        </a>
      </div>
      <div class="demo__margin-top--4">
        <a
          :href="userLinks.privacyPolicy"
          class="demo__pointer demo__color--white"
          target="_blank"
        >
          {{ $t("Policy v2") }}
        </a>
      </div>
    </div>
    <div
      class="demo__flex demo__flex-middle this__3 demo__font--16 demo__weight--500 this__part"
    >
      <div>
        <a
          href="https://thirdopinion.ai/"
          class="demo__pointer demo__color--white"
          target="_blank"
        >
          {{ $t("Site company") }}
        </a>
      </div>
      <div class="demo__margin-left--24">
        <a
          href="tel:+74994606365"
          class="demo__pointer demo__color--white"
          target="_blank"
          >+ 7 (499) 460 63 65</a
        >
      </div>
      <div class="demo__margin-left--24">
        <a
          href="mailto:ask@3opinion"
          class="demo__pointer demo__color--white"
          target="_blank"
        >
          ask@3opinion.ai</a
        >
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["userLinks"]),
  },
  created() {
    this.$accessModule("footer", this);
  },
};
</script>
